import getAxiosBase, { cancelSource } from '@/api/axios-base';
import { DownloadFile, FetchedData } from '@/interfaces';
import downloadFile from '@/helpers/downloadFile';

export async function fetchFile(fileOption: DownloadFile): Promise<boolean> {
  const success: boolean = await getAxiosBase()
    .get(`/notefied/file/${fileOption.endpoint}/`, {
      params: {
        fileName: fileOption.fileName,
        fileType: fileOption.fileType,
        fileFolder: fileOption.fileFolder,
        id: fileOption.id,
      },
      signal: cancelSource,
      responseType: 'arraybuffer',
    })
    .then(async (response) => {
      if (response.status === 200) {
        const file = new Blob([response.data], {
          type: response.headers['content-type'],
        });
        const content = response.headers['content-disposition'];
        downloadFile(file, content.split('filename=')[1]);
        return true;
      }
      return false;
    })
    .catch((error) => {
      console.error(error);
      return false;
    });

  return success;
}

export async function fetchFilesFromBucket():
  Promise<FetchedData> {
  const data = await getAxiosBase()
    .get('notefied/file/bucket/info/')
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
      return {};
    });
  return data;
}
